module.exports = __webpack_public_path__ + "static/media/vn.a9aa6a08.svg";